<template>
  <div class="container mx-auto px-4 lg:px-40 flex flex-1 justify-center py-5">
    <div class="layout-content-container flex flex-col max-w-[960px] flex-1">
      <div class="@container">
        <div class="@[480px]:p-4">
          <div
            class="hero min-h-[480px] flex flex-col gap-6 bg-cover bg-center bg-no-repeat @[480px]:gap-8 @[480px]:rounded-xl items-start justify-end px-4 pb-10 @[480px]:px-10"
            :style="`background-image: url(${heroBackground})`">
            <div class="hero-overlay bg-opacity-60 rounded-xl"></div>
            <div class="hero-content text-center text-neutral-content z-10">
              <h1
                class="text-4xl font-black leading-tight tracking-[-0.033em] @[480px]:text-5xl @[480px]:font-black @[480px]:leading-tight @[480px]:tracking-[-0.033em] relative z-10"
              >
                <span class="bg-black/60 px-2 py-1 rounded text-white drop-shadow-lg">
                  {{ inmob_data.home_page_content.title }}
                </span>
              </h1>
            </div>
            <div class="z-10 w-full">
              <SearchBar />
            </div>
          </div>
        </div>
      </div>

      <!-- Propiedades recomendadas -->
      <PropertySection v-if="recommended_properties" title="Recomendados para vos"
        :properties="recommended_properties" />

      <!-- Nuevas propiedades -->
      <PropertySection v-if="new_properties" title="Últimas publicadas" :properties="new_properties" />
    </div>
  </div>
</template>

<script>
import SearchBar from '@/components/home/SearchBar.vue'
import PropertyCard from '@/components/common/PropertyCard.vue'
import PropertySection from '@/components/common/PropertySection.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'HomeView',
  components: { SearchBar, PropertyCard, PropertySection },
  mounted() {
    this.fetchHomePublications();
  },
  computed: {
    ...mapState({
      inmob_data: state => state.inmob_data,
      recommended_properties: state => state.home.recommended,
      new_properties: state => state.home.latest
    }),
    heroBackground() {
      return `${process.env.VUE_APP_API_BASE_URL}${this.inmob_data.home_page_content.background_image}`
    },
  },
  methods: {
    ...mapActions({
      fetchHomePublications: 'FETCH_HOME_PUBLICATIONS'
    }),
  }
}
</script>
